import { css } from "@emotion/react";

const OriginalInfo: React.FC = () => {
  return (
    <div css={mainStyle} id="introduction">
      <div css={contentsWrapper}>
        <div css={upperTitleWrapperStyle}>
          <div css={borderStyle}></div>
          <div css={titleStyle}>イントロダクション</div>
          <div css={borderStyle}></div>
        </div>
        <div css={backgroundTitleWrapperStyle}>
          <div css={backgroundTitleStyle(260)}>
            累計部数４４０万部突破の話題作
          </div>
          <div css={backgroundTitleStyle(335)}>
            森本梢子の人気原作コミックが初の朗読劇化！
          </div>
        </div>
        <div css={subTitleStyle}>
          『ごくせん』『デカワンコ』『高台家の人々』などで知られる漫画家
          <br />
          森本梢子が描く、話題のコミック『アシガール』。
        </div>
        <div css={infoTxtStyle}>
          足が速いことだけがとりえの女子高生・唯は、弟の尊がつくったタイムマシンを
          <br />
          うっかり起動させてしまったことで、戦国時代にタイムスリップ・・・！ ?
          <br />
          そこで出会った愛しい若君こと羽木九八郎忠清と恋に落ち、彼を守るために
          <br />
          足軽になって奮闘する姿を描くタイムスリップ・ラブコメディです！
          <br />
          そんな大人気コミックが豪華キャスト陣による朗読と
          <br />
          生バンドが手掛けるライブ音楽で朗読劇となって登場！
          <br />
          <br />
          さあ、あなたも『アシガール』の世界へタイムスリップ！
        </div>
      </div>
    </div>
  );
};

const primaryColor = "#DD6B74";

const mainStyle = css`
  width: 100%;
  margin: 30px 0 20px;
  display: flex;
  justify-content: center;
`;

const contentsWrapper = css`
  width: 100%;
  max-width: 500px;
  padding: 10px 20px 20px;
`;

const upperTitleWrapperStyle = css`
  display: flex;
  align-items: center;
`;

const backgroundTitleWrapperStyle = css`
  width: 100%;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const backgroundTitleStyle = (width: number) => css`
  width: ${width}px;
  margin-top: 12px;
  padding: 6px 0px;
  background-color: ${primaryColor};
  font-size: 11pt;
  color: white;
  font-weight: bold;
`;

const borderStyle = css`
  height: 1px;
  background-color: ${primaryColor};
  flex-grow: 1;
`;

const titleStyle = css`
  margin: 0 10px;
  font-size: 12pt;
  font-weight: 500;
`;

const subTitleStyle = css`
  padding-top: 12px;
  font-size: 8pt;
  line-height: 18px;
  font-weight: bold;
`;

const infoTxtStyle = css`
  padding-top: 12px;
  font-size: 6px;
`;

export default OriginalInfo;
